var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlecha2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22915 12.5708C2.22938 12.5711 2.22958 12.5714 2.22985 12.5716L6.31204 16.7652C6.61786 17.0793 7.11251 17.0781 7.41692 16.7624C7.7213 16.4467 7.72012 15.9361 7.4143 15.6219L4.67352 12.8065L21.2188 12.8065C21.6502 12.8065 22 12.4454 22 12C22 11.5546 21.6502 11.1935 21.2188 11.1935L4.67356 11.1935L7.41427 8.37806C7.72009 8.06387 7.72126 7.55326 7.41688 7.23758C7.11247 6.92181 6.61778 6.92072 6.312 7.23484L2.22982 11.4284C2.22958 11.4286 2.22938 11.4289 2.22911 11.4292C1.92313 11.7444 1.92411 12.2567 2.22915 12.5708Z",
    fill: "#FF4F00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecha2);
export default __webpack_public_path__ + "static/media/flecha2.8fc2ed4008dc59174fb2591566b93a43.svg";
export { ForwardRef as ReactComponent };